module.exports = __webpack_public_path__ + "static/biodiversity_LR-2b61651280114fce50b53ab840bf681a.mp4";